module.exports = __webpack_public_path__ + "img/bitab-3.bab7981d.png";